import { useTranslation } from "react-i18next";
import { CATEGORIES } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
      {CATEGORIES.map((cat) => (
        <a
          key={cat.id}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
        >
          <div className="relative w-full aspect-square overflow-hidden bg-background-100">
            <img
              src={cat.image}
              alt={`${t(cat.labelKey)} — AllChinaBuy Spreadsheet`}
              title={`${t(cat.labelKey)} — AllChinaBuy Spreadsheet`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <span className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center rounded-md bg-background-50/90 text-primary-600">
              <i className={`${cat.icon} text-base`} />
            </span>
          </div>
          <div className="flex items-center justify-between gap-2 px-3 py-3">
            <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap truncate">
              {t(cat.labelKey)}
            </span>
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
              <i className="ri-arrow-right-up-line text-xs" />
            </span>
          </div>
        </a>
      ))}
    </div>
  );
}